module.exports = __webpack_public_path__ + "img/web_pay_superpay.cea58b0a.png";